// extracted by mini-css-extract-plugin
export default {"content":"styles_content__bHujY","image":"styles_image__o+nNl","button-wrapper":"styles_button-wrapper__790b7"};